goog.provide('el8.apphome.dialog.patientCheckin');

goog.require('el8.appshared.dialog.patientFields');
goog.require('el8.appshared.eligibility');
goog.require('el8.appshared.form.eligibilityFields');
goog.require('el8.service.urls');
goog.require('el8.template.apphome.dialog.patientCheckin');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');


/**
 * Currently this dialog is designed to get additional
 * information to get patient's eligibility. In future
 * will become a generic patient check-in dialog
 */

el8.apphome.dialog.patientCheckin = (function() {

    var patient = null;
    var closeCb = null; // used when we have another check-in triggered dialog we want to show after this one...

    // primarily used to communicate out to react when triggers this dialog
    // and want to know when pt has been saved
    var _onSaveCallback = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Patient\'s Medication Coverage Eligibility & Medication Fills',
        modal: true,
        autoHeight: true,
        width: 600,
        contentFn: function() {
            return el8.template.apphome.dialog.patientCheckin.content({
                phoneTypes: el8.data.phoneTypes
            });
        }
    });
    var form = new el8.uiwidget.Form({
        fields: el8.appshared.form.eligibilityFields,
        validationOpts: el8.appshared.dialog.patientFields.patientValidationOpts
    });
    form.addButton('check-eligibility', 'Check Eligibility & Retrieve Meds',
        function(_form) {
            if (!_form.isValid()) { return; }
            _form.disable();

            el8.appservice.notifier.notify('Saving patient info...');

            $.el8_ajax({
                url: el8.service.urls.get('patientDemographics', [patient.getId()]),
                type: 'POST',
                async: false,
                data: JSON.stringify(_form.getMapped(false, true)),
                success: function(data) {
                    el8.appservice.notifier.notify('Patient info saved.');
                    if (_onSaveCallback) { _onSaveCallback(data); }
                }
            });

            el8.appshared.eligibility.submitRequest(patient, {
                successCb: function() { 
                    that.hideLoading();
                    that.hide(); 
                },
                failureCb: function() {
                    el8.uiwidget.confirm(
                        'Medication coverage eligibility could not be retrieved. Update patient information and try again?',
                        function() { 
                            that.hideLoading();
                            _form.enable(); 
                            _form.initFocus();
                        },
                        function() { 
                            that.hideLoading();
                            that.hide(); 
                        }
                    );
                },
                pendingCb: function() {
                    that.displayLoading();
                }
            });

        }, true);
    form.addButton('skip', 'Skip',
        function() { that.hide(); }
    );
    that.setForm(form);

    var super_show = that.show;
    that.show = function(opts) {
        opts = opts || {};
        super_show.call(that);
        _onSaveCallback = opts.onSaveCallback ? opts.onSaveCallback : null;

        form.populate(patient.asFormMap());
        form.initFocus();
    };

    that.showAsNeeded = function(opts) {
        closeCb = opts.closeCb;
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('patientCheckinItems', [opts.patientId]),
            success: function(data) {
                if (!data['eligibility_verified']) {
                    patient = el8.ptdata.patients.getById(opts.patientId); // only change the patient right before refreshing the form
                    that.show();
                    if (!data['eligibility_failure_reason']) {
                        that.getContentElt().find('.elig-failure-reason').text('').removeClass('alertCaution');
                    } else {
                        that.getContentElt().find('.elig-failure-reason').text(data['eligibility_failure_reason']).addClass('alertCaution');
                    }
                } else {
                    if (closeCb) { closeCb(); }
                }
            }
        });
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        el8.appservice.notifier.clear();
        if (closeCb) { closeCb(); }
        patient = null;
        closeCb = null;
    };

    return that;

})();


